export default "__VITE_ASSET__B6KdaZQO__"